import React, { useEffect } from "react";
import Hero from "../../../components/Landing/HeroHome";
import Metrices from "../../../components/Landing/Metrices";
import Testemonials from "../../../components/Landing/Testemonials";
import Faqs from "../../../components/Landing/Faqs";
const Home = () => {
  useEffect(() => {
    document.title = "Snilink - Share More with Less";
  }, []);
  return (
    <div className=" bg-white dark:bg-accent-900">
      <Hero />
      <Metrices />
      <Testemonials />
      <Faqs />
    </div>
  );
};

export default Home;
